export const GALLERY_FILTERS = ["All", "Gospel & Worship", "Soul & R&B", "Reggae & Soca", "House, Pop & Disco", "Blues & Jazz", "Urban & Grime", "TV, Film & Sport"];

const G = "Gospel & Worship", S = "Soul & R&B", R = "Reggae & Soca", H = "House, Pop & Disco", J = "Blues & Jazz", U = "Urban & Grime", T = "TV, Film & Sport";
const p = (file, name, category, sub = "") => ({ src: `/media/gallery/${file}`, caption: `With ${name}${sub ? ` ${sub}` : ""}`, name, sub, category });

export const GALLERY = [
  p("adam-blackstone.jpg", "Adam Blackstone", G),
  p("ann-nesby.jpg", "Ann Nesby", G, "(Sounds of Blackness)"),
  p("ashford-simpson.jpg", "Ashford & Simpson", S),
  p("alison-hinds.jpg", "Alison Hinds", R),
  p("angie-le-mar.jpg", "Angie Le Mar", T, "(The Real McCoy)"),
  p("boney-m.webp", "Boney M", H),
  p("courtney-pine.jpg", "Courtney Pine", J),
  p("beverley-knight-ruby-turner.jpg", "Beverley Knight & Ruby Turner", S),
  p("colin-jackson.jpg", "Colin Jackson", T, "(Olympic Champion Hurdler)"),
  p("simon-cowell.jpg", "Simon Cowell", T, "(The X Factor)"),
  p("curtis-walker-felicity-ethnic.jpg", "Curtis Walker & Felicity Ethnic", T, "(The Real McCoy · Comedian)"),
  p("janet-jackson.webp", "Janet Jackson", S),
  p("james-ingram.jpg", "James Ingram", S),
  p("donnie-mcclurkin.jpg", "Donnie McClurkin", G),
  p("edwin-hawkins.jpg", "Edwin Hawkins", G, "(The Edwin Hawkins Singers)"),
  p("gwen-dickey.jpg", "Gwen Dickey", S, "(Rose Royce)"),
  p("kelly-brook.jpg", "Kelly Brook", T, "(Britain's Got Talent)"),
  p("kevin-bond.webp", "Kevin Bond", G),
  p("kym-mazelle.webp", "Kym Mazelle", H),
  p("louis-walsh.jpg", "Louis Walsh", T, "(The X Factor)"),
  p("martha-munizzi.jpg", "Martha Munizzi", G),
  p("maxi-priest.jpg", "Maxi Priest", R),
  p("michael-douglas.jpg", "Michael Douglas", T, "(Wall Street)"),
  p("oleta-adams-piano.jpg", "Oleta Adams", S),
  p("omar.jpg", "Omar", S),
  p("pace-sisters.jpg", "The Pace Sisters", G),
  p("paulette-tajah.jpg", "Paulette Tajah", R),
  p("peabo-bryson.jpg", "Peabo Bryson", S),
  p("ray-chew.jpg", "Ray Chew", G),
  p("ray-russell.webp", "Ray Russell", J),
  p("ade-adepitan.webp", "Ade Adepitan", T, "(Paralympian & Presenter)"),
  p("rhashan-stone-ruby-turner.webp", "Rhashan Stone & Ruby Turner", T, "(Keeping Faith · Jools Holland)"),
  p("richard-smallwood.jpg", "Richard Smallwood", G),
  p("rod-stewart-penny-lancaster.jpg", "Rod Stewart & Penny Lancaster", H),
  p("sharon-osbourne.jpg", "Sharon Osbourne", T, "(The X Factor)"),
  p("sister-sledge.webp", "Sister Sledge", S),
  p("smokie-norful.jpg", "Smokie Norful", G),
  p("tito-jackson.jpg", "Tito Jackson", S, "(The Jackson 5)"),
  p("tony-momrelle.webp", "Tony Momrelle", S, "(Incognito)"),
  p("angela-griffin.webp", "Angela Griffin", T, "(Coronation Street)"),
  p("sharon-d-clarke.webp", "Sharon D. Clarke", T, "(Holby City)"),
  p("myron-butler.webp", "Myron Butler", G),
  p("ashley-banjo.jpg", "Ashley Banjo", T, "(Diversity)"),
  p("angelica.jpg", "Angelica Bell", T, "(The One Show)"),
  p("dean-gaffney.jpg", "Dean Gaffney", T, "(EastEnders)"),
  p("myra-mcqueen.jpg", "Myra McQueen", T, "(Hollyoaks)"),
  p("simon-webbe.webp", "Simon Webbe", S, "(Blue)"),
  p("jennifer-hudson.webp", "Jennifer Hudson", S),
  p("gabrielle.webp", "Gabrielle", S),
  p("david-gest.jpg", "David Gest", T, "(I'm a Celebrity)"),
  p("stormzy.webp", "Stormzy", U),
  p("clive-myrie.webp", "Clive Myrie", T, "(Mastermind)"),
  p("mica-paris.webp", "Mica Paris", S),
  { src: "/media/gallery/film-set.webp", caption: "On a film set", name: "Film set", category: T },
  p("brian-mcfadden.webp", "Brian McFadden", H, "(Westlife)"),
  p("bluey.webp", "Bluey", J, "(Incognito)"),
  p("j-moss.jpg", "J Moss", G),
  p("micah-stampley.webp", "Micah Stampley", G),
  p("heather-small.webp", "Heather Small", H, "(M People)"),
  p("yolanda-brown.webp", "YolanDa Brown", J),
  p("beverley-skeete.webp", "Beverley Skeete", J),
  p("ruby-turner.webp", "Ruby Turner", S),
  p("caron-wheeler.jpg", "Caron Wheeler", S, "(Soul II Soul)"),
  p("womack-womack.jpg", "Womack & Womack", S),
  p("cory-henry.webp", "Cory Henry", J, "(Snarky Puppy)"),
];

const WEEK = 7 * 24 * 60 * 60 * 1000;
const MONDAY = Date.UTC(2024, 0, 1);
export const featuredArtist = (now = Date.now()) => {
  const people = GALLERY.filter((g) => g.name !== "Film set");
  return people[Math.floor((now - MONDAY) / WEEK) % people.length];
};
